import axios from "axios";

// Localhost
// let domain = "http://localhost:5000/";
let domain = "https://sfc-be.austere.biz/"
// let domain = "https://accounts-be.fdms-sfc.com/"


const instance = axios.create({
  baseURL: domain + "sfc/api",
});

const baseUrl = () => {
  return domain;
}

export default instance;
export {
  baseUrl
}